import React, { useEffect, useState } from 'react'
import { Button, Card } from 'react-bootstrap';
import InputField from '../../jsx/components/fields/inputField';
import { txtAccountHolderName, txtAccountNumber, txtIFSCCode, txtYourPayment } from '../../dataBaseFile/label';
import { enterFullName } from '../../dataBaseFile/error';
import { btnAddBank } from '../../dataBaseFile/alert';
import './userProfile.scss'

// import { loadStripe } from '@stripe/stripe-js'
// import { Elements } from '@stripe/react-stripe-js';
// import CheckoutForm from '../paymentComponent/checkoutForm';
import SaveCardDetails from '../paymentModule/saveCardDetails';
import { useSelector } from 'react-redux';
import AddAccountDetails from '../paymentModule/addAccountDetails';
import { FaHandHoldingDollar } from "react-icons/fa6";


const PaymentInfo = () => {
    const { role, permissionArr, companyId, serviceRequestFlagPro } = useSelector((state) => state.user);
    const { totalEarned } = useSelector((state) => state.finance);
    const [renderPaymentTabs, setRenderPaymentTabs] = useState(1);
    const permissionArray = permissionArr[0] || []
    useEffect(() => {
        if (role == 2) {
            setRenderPaymentTabs(2)
        }
    }, [])
    return (
        <>
            <div className='row w-100 mx-0'>
                {/* Pay */}
                <div
                    // Pro connection with own customers flow changes condition removed -> (serviceRequestFlagPro != 1)) 
                    // className={`${(((permissionArray.includes("UPDATE WORK INFORMATION") && !companyId) || (permissionArray.includes("UPDATE WORK INFORMATION") && companyId && totalEarned > 0) || (role == 4)) && (serviceRequestFlagPro != 1)) ? 'col-lg-6' : 'col-12'} px-1`}
                    className={`${(((permissionArray.includes("UPDATE WORK INFORMATION") && !companyId) || (permissionArray.includes("UPDATE WORK INFORMATION") && companyId && totalEarned > 0) || (role == 4))) ? 'col-lg-6' : 'col-12'} px-1`}
                >

                    <SaveCardDetails />
                </div>

                {/* Payouts */}
                {/* Pro connection with own customers flow changes condition removed -> (serviceRequestFlagPro != 1)) */}
                {/* {(((permissionArray.includes("UPDATE WORK INFORMATION") && !companyId) || (permissionArray.includes("UPDATE WORK INFORMATION") && companyId && totalEarned > 0) || (role == 4)) && (serviceRequestFlagPro != 1)) && */}
                {(((permissionArray.includes("UPDATE WORK INFORMATION") && !companyId) || (permissionArray.includes("UPDATE WORK INFORMATION") && companyId && totalEarned > 0) || (role == 4))) &&
                    <div className='col-lg-6 px-1' style={{}}>
                        <AddAccountDetails />
                    </div>
                }
            </div>

            {/* <Card style={{ marginBottom: '10px', position: 'relative', }}>
                <Card.Body>

                    <p className='bio-header'>{txtYourPayment}</p>

                    <div className='d-flex profile-main-content'>
                        <p className='bio-header'>{txtYourPayment}</p>

                        <form onSubmit={(e) => e.preventDefault()} style={{ padding: '5px' }}>

                            <InputField
                                labelName={txtAccountNumber}
                                placeholderName={"XXXX-XXXX-XXXX"}
                                disabled={true}
                            />

                            <div className='combine-input-fileds' >
                                <div className='comapany-address' style={{ width: '49%' }}>
                                    <InputField
                                        labelName={txtIFSCCode}
                                        placeholderName={"XXX"}
                                        disabled={true}
                                    />
                                </div>
                                <div className='comapany-address' style={{ width: '49%' }}>
                                    <InputField
                                        labelName={txtAccountHolderName}
                                        placeholderName={enterFullName}
                                        disabled={true}
                                    />
                                </div>
                            </div>

                            <div className='d-flex align-items-center justify-content-end'>
                                <Button disabled>{btnAddBank}</Button>
                            </div>
                        </form>
                    </div>



                    // <Elements stripe={stripePromise}>
                    // <CheckoutForm />
                    // </Elements> 



                    {role != 2 &&
                        <div className='payment-module-tabs'>
                            <div className='payment-module-individual-tab' onClick={() => setRenderPaymentTabs(1)}>
                                <span
                                    className='payment-module-individual-tab-txt'
                                    style={{
                                        color: renderPaymentTabs === 1 ? '#FC8019' : "",
                                        fontWeight: renderPaymentTabs === 1 ? "700" : ""
                                    }}
                                >Get Paid</span>
                                {renderPaymentTabs === 1 && <div className='payment-module-active-tab'></div>}
                            </div>

                            <div className='payment-module-individual-tab' onClick={() => setRenderPaymentTabs(2)}>
                                <span
                                    className='payment-module-individual-tab-txt'
                                    style={{
                                        color: renderPaymentTabs === 2 ? '#FC8019' : "",
                                        fontWeight: renderPaymentTabs === 2 ? "700" : ""
                                    }}
                                > Billing and Payment</span>
                                {renderPaymentTabs === 2 && <div className='payment-module-active-tab'></div>}
                            </div>
                        </div>}

                    {role != 2 && renderPaymentTabs === 1 && <AddAccountDetails />}
                    {renderPaymentTabs === 2 && <SaveCardDetails />}


                </Card.Body>
            </Card > */}
        </>
    )

}

export default PaymentInfo;